var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V16H16V176H496Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V176H16V336H496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V336H16V496H496Z",
    fill: "#2ECC71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496L176 255.998L16 16V496Z",
    fill: "#3498DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.481 213.88H289.281V283.853C289.281 307.399 258.584 289.26 255.968 301.818C251.434 288.911 222.656 307.573 222.656 282.458C222.656 258.041 222.481 213.88 222.481 213.88Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.677 290.655C260.677 290.655 259.805 291.527 258.236 290.83C256.666 290.132 256.491 246.006 256.491 246.006C259.98 242.169 262.77 240.948 262.77 240.948L264.863 242.692C257.015 246.704 257.712 252.459 258.41 262.401C258.584 266.063 258.584 270.772 259.456 275.307C260.677 281.063 263.119 285.946 263.293 289.609C263.468 291.876 260.677 290.655 260.677 290.655Z",
    fill: "#73452B",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.271 239.902H258.41C255.794 265.192 258.061 280.191 258.061 287.516C258.061 289.958 259.456 290.83 259.282 290.83C256.143 294.318 254.573 290.656 254.573 290.656L255.271 239.902Z",
    fill: "#73452B",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.387 290.656C247.422 292.051 247.073 289.26 247.248 288.912C253.701 275.831 256.492 247.053 250.562 243.914L250.91 241.123C253.178 241.821 255.271 244.786 255.271 244.786C256.143 277.052 255.271 290.307 254.747 290.83C251.608 294.144 250.387 290.307 250.213 289.958",
    fill: "#A36629"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.387 290.656C247.422 292.051 247.073 289.26 247.248 288.912C253.701 275.831 256.492 247.053 250.562 243.914L250.91 241.123C253.178 241.821 255.271 244.786 255.271 244.786C256.143 277.052 255.271 290.307 254.747 290.83C251.608 294.144 250.387 290.307 250.213 289.958",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M250.213 290.132C249.69 287.342 254.747 280.191 254.399 272.691",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M258.759 278.796C260.328 283.156 261.026 286.993 260.677 290.656",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.561 228.042C266.607 226.821 266.607 226.821 268.526 226.821C268.875 224.205 273.235 224.205 273.584 227.519C277.072 226.821 277.77 228.914 276.374 231.007C279.688 230.135 282.653 231.007 281.781 234.844C287.711 236.414 285.444 240.6 282.827 241.472C282.479 244.088 280.037 244.96 276.723 243.914C272.537 246.879 270.096 245.832 268.177 242.867C263.468 243.565 263.119 242.518 261.026 239.902C257.364 241.472 256.666 241.472 253.527 239.553C253.352 241.995 252.48 241.297 250.91 241.123C251.085 244.262 249.864 245.658 247.073 244.611C249.166 248.972 243.76 250.89 241.143 247.227C238.702 247.402 238.527 246.704 237.306 245.832C236.26 249.32 232.423 248.797 231.725 246.879C226.842 246.181 227.365 243.565 231.376 243.39C231.725 240.6 234.167 241.123 235.737 241.472C235.911 239.728 236.957 240.077 237.83 240.425C237.306 239.205 237.655 238.507 239.225 238.158C236.957 235.193 238.353 234.147 240.62 233.1C239.399 230.31 241.492 230.484 243.062 230.31C242.887 227.345 243.76 226.821 246.899 226.473C246.55 225.426 247.073 224.554 248.817 224.554C247.771 221.589 249.166 220.909 252.306 221.415C252.829 217.107 262.073 219.147 261.375 225.077C263.991 225.426 264.863 225.949 265.561 228.042Z",
    fill: "#009A3B",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.899 226.473C247.597 226.821 248.469 226.473 248.643 228.391C250.038 225.949 251.782 227.345 251.782 230.135",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M261.375 225.077C260.677 226.124 258.061 226.124 258.41 228.914C257.538 227.693 255.794 227.344 255.096 228.565",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.561 228.042C265.561 228.74 265.387 230.833 264.689 231.879",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.374 231.007C276.549 231.181 273.933 231.007 272.712 231.879",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M282.827 241.472C282.13 241.123 280.735 240.251 279.688 241.646C279.688 240.949 279.688 239.03 277.77 239.03",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M276.723 243.914C276.723 242.17 276.374 241.646 276.025 241.123",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.968 241.471C269.572 240.425 268.177 241.995 268.177 242.867",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.852 239.902C260.852 239.205 260.328 237.809 261.549 237.286",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.969 247.227C241.318 245.483 242.539 245.483 242.364 244.611C242.19 243.216 240.62 241.995 238.702 243.913",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.364 244.611C243.411 244.262 244.457 244.437 244.806 244.96",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M239.399 238.158C240.097 237.461 241.841 237.635 242.888 238.158",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242.887 233.972C243.76 233.972 245.329 233.623 245.852 235.193C247.771 232.228 249.166 232.577 249.515 233.274",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M253.003 232.926C254.399 232.403 256.84 233.798 258.236 236.24C258.933 234.321 259.98 234.67 261.026 234.495",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M267.654 236.24C269.921 235.193 271.316 237.286 272.014 238.158C273.061 236.763 273.933 236.763 274.979 236.763",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M246.55 240.425C247.073 239.553 248.294 239.379 249.166 239.902C248.992 238.332 250.038 237.635 250.736 237.984",
    stroke: "black",
    strokeWidth: 0.333333
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M253.701 204.078L249.864 204.252L247.945 207.688L245.852 204.409L242.015 204.566L243.759 201.113L241.667 197.834L245.678 197.66L247.422 194.224L249.515 197.503L253.352 197.346L251.608 200.799L253.701 204.078Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M237.306 205.351L233.469 206.293L232.423 210.008L229.632 207.217L225.97 208.124L227.016 204.409L224.4 201.584L228.063 200.659L229.109 196.927L231.9 199.717L235.737 198.81L234.516 202.543L237.306 205.351Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M221.435 208.612L217.947 210.339L217.772 214.211L214.459 212.083L210.97 213.792L211.319 209.92L208.005 207.775L211.494 206.031L211.842 202.159L214.982 204.287L218.47 202.578L218.296 206.45L221.435 208.612Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M258.759 204.078L262.596 204.252L264.34 207.688L266.433 204.409L270.27 204.566L268.526 201.113L270.619 197.834L266.782 197.66L264.863 194.224L262.77 197.503L258.933 197.346L260.677 200.799L258.759 204.078Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M275.153 205.351L278.816 206.293L279.862 210.008L282.653 207.217L286.316 208.124L285.269 204.409L288.06 201.584L284.223 200.659L283.176 196.927L280.386 199.717L276.723 198.81L277.769 202.543L275.153 205.351Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M290.85 208.612L294.339 210.339L294.513 214.211L297.827 212.083L301.315 213.792L301.141 209.92L304.28 207.775L300.792 206.031L300.617 202.159L297.304 204.287L293.815 202.578L294.164 206.45L290.85 208.612Z",
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M295.56 282.458L299.92 288.737L303.931 282.807L301.141 277.749L295.56 282.458Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M267.828 300.771L268.177 307.05C268.177 307.05 269.921 307.05 271.491 306.527C272.886 306.004 274.107 304.957 274.107 304.957L273.932 301.644L267.828 300.771Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M244.457 300.771L244.108 306.876C244.108 306.876 242.539 306.876 240.969 306.527C239.574 306.178 238.353 305.306 238.353 305.306L236.609 301.12L244.457 300.771Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M216.377 282.458L211.842 288.737L206.959 280.714L210.622 276.877L216.377 282.458Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M238.178 313.329C238.178 319.259 274.107 319.259 274.107 313.329V304.957C274.107 309.317 238.178 308.445 238.178 304.957V313.329Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M206.087 293.969C209.226 310.015 238.178 310.364 238.178 310.364V304.957C237.481 302.864 238.702 302.167 243.411 301.469C245.329 301.295 244.457 298.504 244.457 298.504C244.457 298.504 231.9 300.771 223.005 297.283C210.97 292.4 209.226 282.981 209.226 282.981C209.226 282.981 208.354 290.307 206.087 293.969Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M306.024 293.969C303.059 310.015 274.107 310.364 274.107 310.364V304.957C274.63 302.864 273.409 302.167 268.7 301.469C266.782 301.295 267.828 298.504 267.828 298.504C267.828 298.504 280.386 300.771 289.281 297.283C301.141 292.4 302.536 282.981 302.536 282.981C302.536 282.981 303.757 290.307 306.024 293.969Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M208.354 287.865C200.331 283.505 206.61 278.97 207.308 266.063C208.529 273.912 217.424 277.226 216.377 282.284C212.714 282.458 210.97 276.877 209.226 282.981L208.354 287.865Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M303.757 287.865C311.78 283.33 305.152 278.97 304.455 266.063C303.234 273.912 294.513 277.226 295.56 282.284C299.048 282.458 300.792 276.877 302.536 282.981L303.757 287.69V287.865Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16667
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M213.238 293.795L214.11 294.493L212.191 296.585C211.423 297.423 211.238 297.977 211.771 298.487C212.433 299.12 212.899 298.9 213.586 298.155L215.679 295.888L216.377 296.585L214.286 299.025C213.151 300.35 212.097 300.047 211.213 299.221C210.443 298.502 210.002 297.459 211.134 296.177L213.245 293.805L213.238 293.795Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M216.726 296.76L217.598 297.283L217.424 301.469L219.342 298.504L220.214 299.027L217.424 303.562L216.377 303.039L216.552 298.853L214.633 301.818L213.761 301.294L216.726 296.76Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M218.296 304.086L220.737 299.202L221.609 299.725L219.342 304.434L218.296 304.086Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M222.133 299.899L220.207 304.954L222.133 305.655C223.927 306.309 224.77 305.519 225.34 304.002C225.915 302.458 225.664 301.323 223.87 300.601L222.133 299.899ZM222.823 301.124C224.628 301.752 224.738 302.437 224.246 303.677C223.77 304.854 223.325 305.315 221.609 304.431L222.823 301.124V301.124Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M227.888 301.818L224.749 306.527L225.963 306.883L226.664 305.659L228.757 306.182L228.935 307.406L230.149 307.574L228.935 301.996L227.888 301.818ZM228.233 303.043L228.579 305.136L227.187 304.958L228.233 303.043Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M230.871 302.272L230.682 307.677L232.735 307.717C234.643 307.753 235.185 306.737 235.232 305.116C235.279 303.468 234.672 302.473 232.738 302.375L230.871 302.271L230.871 302.272ZM231.918 303.209C233.83 303.217 234.157 303.827 234.09 305.162C234.026 306.43 233.749 307.009 231.842 306.726L231.917 303.209L231.918 303.209Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M249.166 309.841V315.418H250.391V313.326C250.391 313.326 251.437 313.388 252.306 313.158C252.991 312.98 253.467 312.541 253.483 311.458C253.499 310.395 252.881 309.841 251.814 309.841H249.163H249.166ZM250.391 310.709L251.62 310.725C252.646 310.725 252.452 312.279 251.652 312.279H250.391V310.709Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M255.445 309.841L253.174 315.419H254.399L254.922 314.027H257.193L257.716 315.419H258.93L256.663 309.838H255.442L255.445 309.841ZM255.968 311.066L256.837 313.159H255.267L255.968 311.066Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M258.933 314.375L261.898 310.713H259.282V309.841H263.468V310.713L260.329 314.375H263.468V315.422H258.933V314.375Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M276.549 303.562L277.595 303.388L278.119 306.527C278.305 307.644 277.794 308.404 277 308.698C276.095 309.031 274.941 308.726 274.805 307.225L275.677 307.05C275.88 307.949 276.241 308.027 276.66 307.886C276.992 307.774 277.164 307.251 277.072 306.702L276.549 303.562Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M278.293 303.249L279.326 303.053L279.803 305.665C280.008 306.783 280.358 307.259 281.085 307.132C281.988 306.974 282.087 306.469 281.895 305.473L281.253 302.686L282.309 302.526L283.01 305.426C283.42 307.121 282.534 307.794 281.345 308.016C280.31 308.209 279.208 307.946 278.847 306.274L278.293 303.249Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M283.699 305.655L284.572 305.306C284.999 306.074 285.667 306.035 286.186 305.805C286.907 305.487 286.989 304.857 286.633 304.643C286.124 304.339 284.911 304.771 284.258 304.533C283.476 304.248 283.141 303.808 283.181 303.132C283.229 302.318 283.945 301.871 284.723 301.629C285.595 301.359 286.455 301.454 287.013 302.516L285.967 302.864C285.626 302.291 285.188 302.318 284.799 302.502C284.473 302.656 283.965 302.945 284.237 303.41C284.46 303.79 285.741 303.543 286.417 303.571C287.115 303.599 287.679 304.066 287.774 304.737C287.905 305.673 287.559 306.181 286.476 306.603C285.139 307.124 283.933 306.54 283.7 305.655H283.699Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M288.409 301.295L287.013 301.993L286.665 301.12L290.502 299.551L290.85 300.248L289.455 300.946L291.025 304.783L290.153 305.306L288.409 301.295Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M290.676 299.376L291.548 298.853L293.99 303.387L293.118 303.91L290.676 299.376Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M296.606 299.725L297.652 299.376C298.145 300.41 297.406 302.291 295.599 302.252C292.954 302.196 292.668 299.283 293.084 298.322C293.782 296.708 295.739 296.739 296.606 297.632L295.734 298.329C295.181 297.62 293.953 298.067 293.87 298.72C293.735 299.784 294.203 300.776 295.155 301.246C295.963 301.644 297.207 300.642 296.606 299.725L296.606 299.725Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M296.083 296.063L296.955 295.365L300.094 299.551L299.222 300.249L296.083 296.063Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M299.397 293.446L298.528 294.147L300.443 299.38L301.312 298.511L300.788 297.465L302.358 296.062L303.405 296.586L304.284 295.895L299.397 293.446ZM299.742 294.671L301.49 295.539L300.443 296.586L299.742 294.671Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGq);
export default __webpack_public_path__ + "static/media/GQ.3d230c99add27ba3f95e83c8133c838e.svg";
export { ForwardRef as ReactComponent };